import { render, staticRenderFns } from "./Milan-19-20-Home.vue?vue&type=template&id=12fd8434&"
import script from "./Milan-19-20-Home.vue?vue&type=script&lang=js&"
export * from "./Milan-19-20-Home.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports